import React, { useRef } from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "react-bootstrap/Card";
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { sliderSpeed } from "../../utils/constants";
import LazyMedia from "../LazyMedia";

interface Props {
  data: any
}

const EduFairStudentTestimonials: React.FC<Props> = ({ data }) => {
  const sliderRef = useRef<Slider>(null);
  const settings = {
    dotsClass: styles.sliderDots,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    autoplay: true,
    speed: 500,
    infinite: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          dots: true,
        }
      }
    ]
  };
  const settingsvedio = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: true,
    speed: sliderSpeed.mobileSpeed,
    autoplaySpeed: sliderSpeed.mobileAutoplaySpeed,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, 
    autoplay: true,
  };

  const settingDesktopVideo = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: true,
    speed: sliderSpeed.desktopSpeed,
    autoplaySpeed: sliderSpeed.desktopAutoplaySpeed,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false, 
    autoplay: true,
  }

  return (
    <>
      <div id="student-testimoney" className={styles.studentTesti} style={{ background: data?.sectionBgColor || '#EEF2FB' }}>
        <Container>
          <div className={styles.testimonials}>
            <Row>
              <div className={styles.heading}>
                <h2>{data?.sectionTitle}</h2>
              </div>
            </Row>
            <div className={styles.studentVedio}>
              {/* desktop view */}
              <div className="d-none d-sm-block">
                {data?.videoUrls?.length > 2 ? 
                ( <Slider {...settingDesktopVideo}>
                  {data?.videoUrls.map((videoUrl: any) => (
                    <div className={styles.studVedio}>
                      <LazyLoadComponent>
                        <LazyMedia width="100%" src={videoUrl?.imageUrl} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" iframeClassName={styles.ipadiframe} tag="iframe"></LazyMedia>
                      </LazyLoadComponent>
                    </div>
                  ))}
                </Slider>
                ):(
                  <Row className="justify-content-center">
                    {data?.videoUrls?.length > 0 &&
                      data?.videoUrls.map((videoUrl: any) => (
                        <Col lg={6} xl={6} md={6} sm={12} className={styles.col}>
                          <div className={styles.studVedio}>
                            <LazyLoadComponent>
                              <LazyMedia width="100%" src={videoUrl?.imageUrl} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" iframeClassName={styles.ipadiframe} tag="iframe"></LazyMedia>
                            </LazyLoadComponent>
                          </div>
                        </Col>
                      ))}
                  </Row>
                  )}
              </div>
              {/* mobile view */}
              <div className="d-block d-sm-none">
                <div className={styles.vedioStuSlidr}>
                  <Slider {...settingsvedio} className={styles.slider}>
                    {data?.videoUrls?.length > 0 &&
                      data?.videoUrls.map((videoUrl: any) => {
                        return (
                          <div className={styles.studVedio}>
                            <LazyLoadComponent>
                              <LazyMedia width="100%" height="200" src={videoUrl?.imageUrl} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></LazyMedia>
                            </LazyLoadComponent>
                          </div>
                        )
                      })
                    }
                  </Slider>
                </div>
              </div>
            </div>
            <Row>
              <div className={styles.stuSchSlider} >
                <Slider {...settings} ref={sliderRef} className={styles.slider}>
                  {
                    data?.testimonials?.length > 0 &&
                    data?.testimonials.map((td: any) => {
                      return (
                        <div className={styles.sliderCardDiv}>
                          <Card className={styles.cardCust}>
                            <div className={styles.studeImgDiv}>
                              <div className={styles.stImg}>
                                <CustomImage src={td?.studentImageUrl || '/'} width={160} height={160} className={styles.cardImg} alt="Arusha-Kelkar.png" />
                              </div>
                              <div className={styles.stuName}>
                                <h4>{td?.studentName}</h4>
                                <p>{td?.studentUniversity}</p>
                              </div>
                            </div>
                            <Card.Body className={styles.cardBody}>
                              <div className={styles.studenSay}>
                                <div>
                                  <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z" fill="#226CF5" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z" fill="#226CF5" />
                                  </svg>
                                </div>
                                <div className={styles.stupara}>
                                  <p>{td?.message}</p>
                                </div>

                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      )
                    })
                  }
                </Slider>
                {data?.testimonials?.length > 3 && <div className={styles.arrowsClass}>
                  <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                    <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                  </div>
                  <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                    <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                  </div>
                </div>}
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}
export default EduFairStudentTestimonials;